/**
 * Keeps the handwriting journey pointer (`@capacitor/preferences`) aligned with product rules.
 *
 * **Navigation:** Clearing on `router.afterEach` only sees **this** Nuxt app. Users may visit a
 * **separate in-house storefront** (same tab, full page) and return — the pointer remains in
 * localStorage for that round trip; `sessionStorage` here usually keeps the bootstrap flag so we
 * do not re-run “first load” cleanup on every return.
 *
 * **New tab:** First paint in a new tab clears the pointer so localStorage does not resurrect an old
 * draft. Optional: clear-on-background via [@capacitor/app](https://capacitorjs.com/docs/apis/app).
 */
import {
    HANDWRITING_POINTER_SESSION_STORAGE_KEY,
    clearProfileInProgressHandwritingSilent,
    isHandwritingJourneyPath,
} from '@/composables/useHandwritingInProgressPointer'

export default defineNuxtPlugin(() => {
    const router = useRouter()

    if (!sessionStorage.getItem(HANDWRITING_POINTER_SESSION_STORAGE_KEY)) {
        sessionStorage.setItem(HANDWRITING_POINTER_SESSION_STORAGE_KEY, '1')
        void clearProfileInProgressHandwritingSilent()
    }

    router.afterEach((to, from) => {
        const fromPath = from?.path ?? ''
        const toPath = to.path
        if (isHandwritingJourneyPath(fromPath) && !isHandwritingJourneyPath(toPath)) {
            void clearProfileInProgressHandwritingSilent()
        }
    })
})
